import React from 'react';
import Header22 from './Header22';
import TestimonialCard22 from './TestimonialCard22';
import CTAButton22 from './CTAButton22';
import FeaturePoint22 from './FeaturePoint22';
import { CheckCircleIcon, HeartIcon, UsersIcon } from 'lucide-react';
const Advertorial22 = () => {
  return <div className="max-w-4xl mx-auto bg-white shadow-md font-serif border border-gray-200" data-id="element-1110">
      <Header22 data-id="element-1111" />
      <main className="px-4 sm:px-8 py-8" data-id="element-1112">
        <div className="prose max-w-none" data-id="element-1113">
          <div className="flex items-center text-xs text-gray-500 mb-8 border-b border-gray-200 pb-2" data-id="element-1114">
            <div className="flex items-center mr-4" data-id="element-1115">
              <HeartIcon className="h-3 w-3 mr-1" data-id="element-1116" />
              <span data-id="element-1117">Personal Health Journey</span>
            </div>
            <div className="flex items-center" data-id="element-1118">
              <UsersIcon className="h-3 w-3 mr-1" data-id="element-1119" />
              <span data-id="element-1120">Success Stories</span>
            </div>
          </div>

          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-1121">
            My Brother Was Skeptical About Hair Growth Caps. Then He Tried This.
          </h1>

          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-1122">
            He called it "magic hat nonsense." I called it science. Six months
            later, we were both looking at a full head of hair that shouldn't
            have been there.
          </p>

          <div className="sm:flex items-center mb-8" data-id="element-1123">
            <div className="sm:w-1/2 mb-4 sm:mb-0 sm:mr-6" data-id="element-1124">
              <img src="https://cdn.magicpatterns.com/uploads/dbRgGY67ZCZ5et19RGx9nr/Daniel_Weiss.jpg" alt="Daniel before and after" className="w-full rounded-lg shadow-md" data-id="element-1125" />
              <p className="text-xs text-gray-500 mt-2 italic text-center" data-id="element-1126">
                Daniel, Month 0 vs Month 6
              </p>
            </div>
            <div className="sm:w-1/2" data-id="element-1127">
              <p className="mb-4 text-base" data-id="element-1128">
                "It's the family curse, Maggie. Just let it go."
              </p>
              <p className="mb-4 text-base" data-id="element-1129">
                That's what my brother Daniel told me when I suggested he try
                red light therapy. At 52, he had resigned himself to the same
                fate as our father and grandfather: the horseshoe pattern.
              </p>
              <p className="mb-4 text-base" data-id="element-1130">
                As a Nurse Practitioner, I knew better. I knew that hair
                follicles don't just "die" overnight—they shrink. They go
                dormant. And if you catch them in time, they can be woken up.
              </p>
              <p className="mb-0 text-base font-bold" data-id="element-1131">
                But I also knew he was right to be skeptical. The market is
                flooded with junk.
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-1132">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-1133"></span>
            The "Last Resort" Experiment
          </h2>

          <p className="mb-5 text-base" data-id="element-1134">
            I made him a deal: "I've been investigating medical devices for 30
            years. Let me find you one that actually meets clinical standards.
            If it doesn't work in 6 months, I'll pay for your shave kit."
          </p>
          <p className="mb-5 text-base" data-id="element-1135">
            He agreed. But I had my work cut out for me.
          </p>

          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 my-8" data-id="element-1136">
            <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-1137">
              Why Most Treatments Fail
            </h3>
            <div className="space-y-4" data-id="element-1138">
              <FeaturePoint22 data-id="element-1139">
                <strong data-id="element-1140">Pills:</strong> Daniel refused finasteride due to side
                effect risks.
              </FeaturePoint22>
              <FeaturePoint22 data-id="element-1141">
                <strong data-id="element-1142">Creams:</strong> Messy, greasy, and require twice-daily
                application forever.
              </FeaturePoint22>
              <FeaturePoint22 data-id="element-1143">
                <strong data-id="element-1144">Cheap Caps:</strong> Most lose power after a few weeks,
                leading to "yo-yo" regrowth.
              </FeaturePoint22>
            </div>
          </div>

          <p className="mb-5 text-base" data-id="element-1145">
            I needed something that was safe, easy, and <em data-id="element-1146">durable</em>. That's
            when I found <strong data-id="element-1147">Glokore</strong>.
          </p>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-1148">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-1149"></span>
            The Turning Point: Week 12
          </h2>

          <p className="mb-5 text-base" data-id="element-1150">
            For the first month, Daniel complained. "I look like a cyclist from
            the future," he'd text me. "Nothing is happening."
          </p>
          <p className="mb-5 text-base" data-id="element-1151">Then came Week 12.</p>
          <p className="mb-5 text-base" data-id="element-1152">
            We were at a family barbecue. The sun was hitting his head, and I
            saw it: a fuzz of pigmented hair on his temples—an area that had
            been smooth skin for five years.
          </p>

          <div className="border-l-4 border-green-500 pl-5 py-4 bg-green-50 rounded-r my-6" data-id="element-1153">
            <p className="text-lg font-serif italic text-gray-800 mb-2" data-id="element-1154">
              "I went to my barber yesterday," Daniel told me, his voice
              actually shaking a little. "He asked me if I was getting plugs. He
              said he had to use a different guard on his clippers because the
              hair was thicker."
            </p>
          </div>

          <p className="mb-5 text-base" data-id="element-1155">
            That was the moment the skepticism died.
          </p>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-1156">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-1157"></span>
            Why This Cap Worked (When Others Didn't)
          </h2>

          <p className="mb-5 text-base" data-id="element-1158">
            Daniel wasn't the first person I'd recommended RLT to. But he was
            the first to see such sustained results. Why?
          </p>
          <p className="mb-5 text-base" data-id="element-1159">
            It comes down to <strong data-id="element-1160">consistency</strong>.
          </p>
          <p className="mb-5 text-base" data-id="element-1161">
            Most caps degrade. They get hot, the LEDs dim, and the wavelength
            shifts. You think you're treating your hair, but you're just wearing
            a warm hat.
          </p>
          <p className="mb-5 text-base" data-id="element-1162">
            The Glokore cap uses NASA-derived thermal protection. It kept
            delivering the exact same dosage of light on Day 180 as it did on
            Day 1.
          </p>

          <div className="my-8" data-id="element-1163">
            <img src="https://cdn.magicpatterns.com/uploads/kCkvJQ6m2138XaN4WdR7aB/At_Daniels.png" alt="Checking results" className="w-full rounded-lg shadow-md mb-2" data-id="element-1164" />
            <p className="text-xs text-gray-500 text-center" data-id="element-1165">
              Verifying the density with a trichoscope.
            </p>
          </div>

          <h2 className="text-2xl font-serif font-bold text-gray-800 mt-12 mb-6 border-b border-gray-800 pb-2 flex items-center" data-id="element-1166">
            <span className="inline-block w-4 h-4 bg-gray-800 mr-3" data-id="element-1167"></span>
            It's Not Just About Hair
          </h2>

          <p className="mb-5 text-base" data-id="element-1168">
            The most important change wasn't the hair count. It was Daniel.
          </p>
          <p className="mb-5 text-base" data-id="element-1169">
            He stopped wearing baseball caps to dinner. He started looking
            people in the eye again. He looked ten years younger, not just
            because of the hair, but because the "old man" resignation was gone.
          </p>
          <p className="mb-5 text-base" data-id="element-1170">
            If you're skeptical like Daniel, I get it. But don't let skepticism
            rob you of a solution that actually works.
          </p>

          <div className="border-t border-b border-gray-300 py-8 my-12 bg-gray-50" data-id="element-1171">
            <h3 className="text-xl font-medium text-gray-800 mb-5 text-center border-b border-gray-300 pb-3" data-id="element-1172">
              Try The Cap That Changed Daniel's Mind
            </h3>
            <CTAButton22 data-id="element-1173" />
            <div className="text-xs text-gray-500 mt-3 text-center" data-id="element-1174">
              60-day money-back guarantee. Zero risk to try.
            </div>
          </div>

          <div className="my-8" data-id="element-1175">
            <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-1176">
              Others Who Took The Leap
            </h3>
            <TestimonialCard22 name="Michael K." location="Austin, TX" duration="8 months" testimonial="I was exactly like Daniel. Thought it was snake oil. My wife bought it for me. I ate my words about 4 months in. It works." data-id="element-1177" />
            <TestimonialCard22 name="David P." location="London, UK" duration="1 year" testimonial="Best investment I've made for my confidence. It's easy, it's painless, and unlike the pills, I don't worry about side effects." data-id="element-1178" />
          </div>
        </div>
      </main>

      <div className="px-4 sm:px-8 py-6 border-t border-gray-200 bg-gray-50" data-id="element-1179">
        <div className="max-w-4xl mx-auto text-[10px] text-gray-400 leading-tight" data-id="element-1180">
          <p className="mb-2" data-id="element-1181">
            These statements have not been evaluated by the Food and Drug
            Administration.
          </p>
          <p data-id="element-1182">This is a paid advertisement for Glokore.</p>
        </div>
      </div>
      <div className="bg-black h-3 w-full" data-id="element-1183"></div>
    </div>;
};
export default Advertorial22;